export { CHIP_DISCOUNT_COLOR } from './colors';